import React from "react";
// import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import "./useful.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import moment from "jalali-moment";

//input
export function Myinput(props) {
  return (
    <div class={props.class}>
      <div class="form-group textg">
        <label class="control-label" for="first_name">
          {props.name}
        </label>
        <input
          id={props.id}
          type={props.type}
          class="contactInput form-control"
          name="first_name"
          placeholder="..."
        />
      </div>
    </div>
  );
}

//logo
export function Mylogo(props) {
  return (
    <div>
      <img src={props.src} alt={props.alt} class={props.class} />
    </div>
  );
}

//drapdown list

//titel
export function Title1(props) {
  return (
    <div class="textg">
      <h4>{props.name}</h4>
    </div>
  );
}

//Toggle
export function Toggle(props) {
  return (
    <div class={props.class}>
      <form>
        <div class="custom-control custom-switch">
          <input
            // onclick={props.onClick}
            value={props.value}
            name={props.name}
            onchange={props.onChange}
            checked={props.checked}
            type="checkbox"
            class="custom-control-input"
            id={props.id}
          />
          <label
            name={props.name}
            value={props.value}
            class="custom-control-label"
            for={props.id}
          >
            {" "}
            {props.title}
          </label>
        </div>
      </form>
    </div>
  );
}
export class ModalDetailorder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          style={{ marginTop: "5rem" }}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            <div>
              {" "}
              {this.props.address}
              <span className="float-right"> آدرس : </span>
            </div>

            <div>
              {" "}
              {this.props.desc}
              <span className="float-right"> توضیحات : </span>
            </div>

            <div>
              {" "}
              {this.props.tell}
              <span className="float-right"> شماره ثابت : </span>
            </div>

            <div>
              {" "}
              {this.props.insta}
              <span className="float-right"> اینستاگرام : </span>
            </div>

            <div>
              {" "}
              {this.props.website}
              <span className="float-right"> وب سایت : </span>
            </div>

            <div>
              {" "}
              {this.props.whatsapp}
              <span className="float-right"> واتزاپ : </span>
            </div>

            <div>
              {" "}
              {this.props.telegram}
              <span className="float-right"> تلگرام : </span>
            </div>
            {/* <div>
              {" "}
              {this.props.onlinePayCode}
              <span className="float-right"> کد پرداخت آنلاین : </span>
            </div> */}
            <div>
              {" "}
              {this.props.createDatetime &&
                moment(
                  this.props.createDatetime && this.props.createDatetime,
                  "YYYY-MM-DD"
                )
                  .locale("fa")
                  .format("YYYY-MM-DD")}
              <span className="float-right"> تاریخ ثبت : </span>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export class ModalDetailorder1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          style={{ marginTop: "5rem" }}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            <div>
              {" "}
              {this.props.amount}
              <span className="float-right"> هزینه : </span>
            </div>

            <div>
              {" "}
              {this.props.isSucess == true ? "موفق" : "ناموفق"}
              <span className="float-right"> پرداخت : </span>
            </div>

            <div>
              {" "}
              {this.props.systemTraceNo}
              <span className="float-right"> کد پیگیری : </span>
            </div>

            <div>
              {" "}
              {this.props.retrivalRefNo}
              <span className="float-right"> کد پرداخت : </span>
            </div>

            <div>
              {" "}
              {/* {console.log(this.props.payDateTime.substring(0, 10))} */}
              {this.props.payDateTime &&
                moment(
                  this.props.payDateTime && this.props.payDateTime,
                  "YYYY-MM-DD"
                )
                  .locale("fa")
                  .format("YYYY-MM-DD")}
              <span className="float-right"> تاریخ ثبت : </span>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export class ModalDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          style={{ textAlign: "right", marginTop: "5rem" }}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", marginTop: "3rem" }}>
            <div> آدرس: {this.props.address}</div>

            <div> رایانامه :{this.props.email}</div>
            <div> کد معرف:{this.props.introducerCode}</div>
            <div> کد صنفی:{this.props.businessCode}</div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export class ModalDetailOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          style={{ marginTop: "5rem" }}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right" }}>
            <div> توضیحات : {this.props.description}</div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export class ModalDetailuser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          style={{ marginTop: "5rem" }}
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right" }}>
            <div> آدرس: {this.props.address}</div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export class ModalDetailprice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }
  render() {
    return (
      <div>
        <Button color="primary" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          style={{ textAlign: "right", marginTop: "5rem" }}
        >
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody style={{ textAlign: "right", overflow: "scroll" }}>
            {this.props.storePrices &&
              this.props.storePrices.map((item, index) => (
                <>
                  {" "}
                  <div> حداقل تعداد: {item.minCount}</div>
                  <div> قیمت: {item.price}</div>
                  <div> قیمت با تخفیف: {item.discountPrice}</div> <hr />
                </>
              ))}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggle}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
